export const PROMOTIONAL_MESSAGING_KEYS = [
  'DTCC_PROMO_FINANCING_AVAILABLE',
  'DTCC_PROMO_MORE_DETAILS_LINK_MESSAGE',
  'DTCC_PROMO_MORE_DETAILS_LINK_URL'
];

export const MONTHLY_MESSAGING_KEYS = [
  'DTCC_PROMO_FINANCING_DETAILS',
  'DTCC_PROMO_MODAL_TRIGGER_MESSAGE'
];

export const IMAGE_KEYS = {
  at: [
    'DTCC_PROMO_IMAGE_AMERICASTIRE_URL',
    'DTCC_PROMO_IMAGE_AMERICASTIRE_ALTTEXT'
  ],
  dt: [
    'DTCC_PROMO_IMAGE_DISCOUNTTIRE_URL',
    'DTCC_PROMO_IMAGE_DISCOUNTTIRE_ALTTEXT'
  ]
};
